// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SnakeCaseToTitleCasePipe } from './snake-case-to-title-case';
import { DealerIdTransformPipe } from './dealer-id-transform';
import { PhonePipe } from './phone.pipe';

@NgModule({
    declarations: [DealerIdTransformPipe, PhonePipe, SnakeCaseToTitleCasePipe],
    exports: [DealerIdTransformPipe, PhonePipe, SnakeCaseToTitleCasePipe],
    imports: [CommonModule],
    providers: [PhonePipe],
})
export class PipesModule {}
